/**
 * Alert Banner — updates the --site-header-h CSS variable so the body
 * dynamically compensates for the total site-header height (banner + navbar).
 */
(function () {
  function updateSiteHeaderHeight() {
    const siteHeader = document.querySelector('.site-header');
    if (!siteHeader) return;
    document.documentElement.style.setProperty(
      '--site-header-h',
      siteHeader.offsetHeight + 'px'
    );
  }

  document.addEventListener('DOMContentLoaded', updateSiteHeaderHeight);
  window.addEventListener('resize', updateSiteHeaderHeight);
})();
